import React, { useState } from "react";
import { QueryRenderer, graphql } from "react-relay";
import environment from "../Environment";
import { GC_USER_ID, GC_AUTH_TOKEN } from "../constants";
import AddSourceModal from "./AddSourceModal";
import AddSourceModalComponent from "./AddSourceModalComponent";

const userSubscriptionQuery = graphql`
	query AddSourceModalComponentContainerSubscriptionQuery($id: ID!) {
		subscriptions(user: $id) {
			...AddSourceModalComponent_user_Subscription
		}
	}
`;

function AddSourceModalComponentContainer(props) {
	const uid = localStorage.getItem(GC_USER_ID);
	const [userId, setUserId] = useState(uid);
	let settings = props.settings;

	const {
		selectedSubId,
		selectedSubName
	} = props;

	console.log("Selected SubId: " + props.selectedSubId);

	return (
		<QueryRenderer
			environment={environment}
			query={userSubscriptionQuery}
			variables={{ id: userId }}
			render={({ error, props }) => {
				if (error) {
					return <div>Error!</div>;
				}
				if (!props) {
					return <div>Loading...</div>;
				}
				return (
					<div>
						<AddSourceModalComponent
							title="Add New Source"
							selectedSubId={selectedSubId}
							selectedSubName={selectedSubName}
							user_Subscription={props.subscriptions}
						/>
					</div>
				);
			}}
		/>
	);
}

export default AddSourceModalComponentContainer;
